import { createAsyncThunk } from '@reduxjs/toolkit';

import { IPermissions, TPaymentAdjustmentTypes } from '.';
import { AdminApiPaths, TApiResponse, APIDataProvider } from '../../../api';
import { TFlexiblePlanExpiredInTypes } from '../FlexiblePlansSlice';

export type TAdminPaymentAdjustmentCreate = {
  userId: string;
  type: TPaymentAdjustmentTypes;
  flexiblePlanId?: string;
  description?: string;
  numberOfHours?: number;
  rate?: number;
  currency?: string;
  courseId?: string;
  expiredIn?: {
    count: number;
    type: TFlexiblePlanExpiredInTypes;
  };
};

export type TAdminTransferCourseCredits = {
  fromCourseId: string;
  toCourseId: string;
  studentId: string;
  fromCourseRate: number;
  toCourseRate: number;
  creditHours: number;
  currency: string;
};

const apiDataProvider = new APIDataProvider();

export const adminGetPermissions = createAsyncThunk(
  '/admin/settings/permissions/get',
  async () => {
    const path = `${AdminApiPaths.adminSettings}/permissions`;
    const response = await apiDataProvider.get<TApiResponse<IPermissions>>(
      path
    );

    return response.data;
  }
);

export const adminCreatePaymentAdjustment = createAsyncThunk(
  '/admin/settings/payment-adjustments/create',
  async (data: TAdminPaymentAdjustmentCreate) => {
    const path = `${AdminApiPaths.adminSettings}/payment-adjustments`;
    const response = await apiDataProvider.post<
      TApiResponse<{ status: string }>
    >(path, data);

    return response.data;
  }
);

export const adminTransferCourseCredits = createAsyncThunk(
  '/admin/settings/transfer-course-credits',
  async (data: TAdminTransferCourseCredits) => {
    const path = `${AdminApiPaths.adminSettings}/transfer-course-credits`;
    const response = await apiDataProvider.put<
      TApiResponse<{ status: string }>
    >(path, data);

    return response.data;
  }
);
